export const CELL_SIZE_PX = 17

const MAX_TRAIL_PIXELS = 48

export type GridPosition = {
  x: number
  y: number
}

type RectLike = Pick<DOMRect, 'height' | 'left' | 'top' | 'width'>

export function getGridDimensions(width: number, height: number) {
  return {
    height: Math.ceil(Math.max(0, height) / CELL_SIZE_PX),
    width: Math.ceil(Math.max(0, width) / CELL_SIZE_PX),
  }
}

export function getTrailGridPosition(
  clientX: number,
  clientY: number,
  rect: RectLike,
  gridWidth: number,
  gridHeight: number,
): GridPosition | null {
  const offsetX = clientX - rect.left
  const offsetY = clientY - rect.top

  if (offsetX < 0 || offsetX >= rect.width || offsetY < 0 || offsetY >= rect.height) {
    return null
  }

  const x = Math.floor(offsetX / CELL_SIZE_PX)
  const y = Math.floor(offsetY / CELL_SIZE_PX)

  if (x >= gridWidth || y >= gridHeight) {
    return null
  }

  return {x, y}
}

export function shouldCreateTrailPixel(
  lastPosition: GridPosition | null,
  nextPosition: GridPosition,
  prefersReducedMotion: boolean,
  positionIsOccupied = false,
) {
  return (
    !prefersReducedMotion &&
    !positionIsOccupied &&
    (lastPosition?.x !== nextPosition.x || lastPosition?.y !== nextPosition.y)
  )
}

export function getEvictedTrailPixelIds(pixelIds: number[], maxPixels = MAX_TRAIL_PIXELS) {
  return pixelIds.slice(0, Math.max(0, pixelIds.length - maxPixels))
}
